import React from 'react'
import GAQuickTalesContainer from '../../modules/GAQuickTales/containers/GAQuickTalesContainer/GAQuickTalesContainer'

const GAQuickTales = () => {
  return (
    <GAQuickTalesContainer />
  )
}

export default GAQuickTales